import { MuiThemeProvider } from '@material-ui/core/styles'
import { BrowserRouter, Route } from 'react-router-dom'
import configureStore from '../src/AppRedux/store'
import { Provider } from 'react-redux'
import theme from './themes'
import Routes from '../src/routes'
import './App.css'
import LandingPage from './layouts/LandingPage'

export const store = configureStore()

function App() {
  return (
    <MuiThemeProvider theme={theme}>
      <Provider store={store}>
        <BrowserRouter>
          <Route path="/" component={Routes} />
        </BrowserRouter>
      </Provider>
    </MuiThemeProvider>
  )
}

export default App
